import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  gridContainer: {
    minHeight: '100%',

    '& .sticky-footer': {
      [Theme.breakpoints.up('sm')]: {
        padding: '16px 30px',
      },
      [Theme.breakpoints.up('md')]: {
        padding: '16px 50px',
      },
      [Theme.breakpoints.up('xl')]: {
        padding: '16px 0',
      },
      '& button': {
        fontFamily: Theme.typography.base.semiBold,
        fontSize: Theme.typography.size[1],
        textTransform: `${isCelebrity ? 'uppercase' : 'initial'}`,
        width: '100%',
        padding: '8px 20px',
        borderRadius: `${isCelebrity ? '1px' : '4px'}`,

        [Theme.breakpoints.up('sm')]: {
          fontSize: Theme.typography.size[2],
          width: 'auto',
          padding: '13px 30px',
        },

        [Theme.breakpoints.up('xl')]: {
          fontSize: Theme.typography.size[3],
        },

        '&.MuiButton-containedPrimary': {
          backgroundColor: `${
            isCelebrity ? Theme.palette.primary.main : Theme.palette.primary.light
          }`,
        },

        '&.Mui-disabled': {
          backgroundColor: `${Theme.palette.gray[500]}`,
          color: Theme.palette.gray[200],
        },
      },
      width: '100%',
      '& .MuiButtonBase-root': {
        margin: 0,
      },
    },
  },

  footerWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: Theme.palette.white,
    position: 'sticky',
    bottom: 0,

    [Theme.breakpoints.up('1441')]: {
      position: 'absolute',
      left: 0,
      width: '100vw',
      bottom: 0,
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
    },

    [Theme.breakpoints.down('lg')]: {
      height: '100%',
      marginBottom: '-17px',
    },

    '& footer': {
      boxSizing: 'border-box',
      [Theme.breakpoints.up('lg')]: {
        maxWidth: 1080,
        margin: '0 auto',
        boxShadow: 'none',
      },
    },
  },

  guestInfoContainer: {
    position: 'relative',
    minHeight: '78vh',
    display: 'flex',
    flexDirection: 'column',
    margin: '0',
    width: '100%',
    fontFamily: Theme.typography.base.regular,

    [Theme.breakpoints.up('lg')]: {
      minHeight: '80vh',
    },
  },
  notification: {
    paddingBottom: 20,
  },
  guestInfoCardWrapper: {
    boxSizing: 'border-box',
    minHeight: '68vh',
    margin: '0 auto 120px',
    maxWidth: '1080px',
    width: '100%',
    paddingLeft: 20,
    paddingRight: 20,
    [Theme.breakpoints.up('sm')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [Theme.breakpoints.up('md')]: {
      paddingLeft: 50,
      paddingRight: 50,
    },
    [Theme.breakpoints.up('xl')]: {
      padding: 0,
    },

    '& .MuiScopedCssBaseline-root:nth-child(2)': {
      [Theme.breakpoints.up('1441')]: {
        marginBottom: 110,
      },
    },
    [Theme.breakpoints.down('sm')]: {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    '& .MuiScopedCssBaseline-root': {
      marginBottom: '16px',
    },
  },
  guestInfoCard: {
    borderRadius: '5px',
    boxShadow: `0 2px 4px 0 ${Theme.palette.shadowOpacity}`,
    padding: '40px',
  },

  progressLineContainer: {
    marginBottom: '20px',
    width: '100%',
    [Theme.breakpoints.up('md')]: {
      marginBottom: '30px',
    },
  },
  airFooter: {
    width: '100%',
    marginBottom: 30,
    position: 'absolute',
    bottom: 0,
    paddingRight: 0,
    paddingLeft: 0,

    [Theme.breakpoints.up('1441')]: {
      bottom: 92,
    },
  },
}));

export default useStyles;
